import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../redux/actions';
import text from '../../text';

export const JOB_FAILURE_MODAL = 'JOB_FAILURE_MODAL';

const JobFailureModal = (props) => {
  const dispatch = useDispatch();

  const onHide = () => {
    dispatch(hideModal(JOB_FAILURE_MODAL));
    props.onHide && props.onHide();
  };

  return (
    <Modal centered {...props} onHide={onHide}>
      <Modal.Body>
        <div>
          <h2>{text('orderCouldNotSaved')}</h2>
          <p className='text-center'>{text('orderCouldNotSavedAtTime')}</p>
          <p className='text-center'>{text('pleaseTryAgainApologise')}</p>
          <div className='form-footer'>
            <Button
              type='button'
              className='metromap-modal-button'
              onClick={onHide}
            >
              {text('returnToMap')}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default JobFailureModal;
